<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">General Search</label>
              <vs-input type="text" class="w-full"
                        v-model="filters['search']"
                        @keyup.enter="getMasBalanceReportData"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Sundry Item Stock Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['In_Stock', 'Out_of_Stock', 'Expired']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">
              <div class="btn-group float-right">
                <vs-button color="danger" size="small" @click="onClickClearSearch">Clear</vs-button>
                <vs-button class="ml-2" color="success" size="small" @click="getMasBalanceReportData">Search</vs-button>
              </div>
            </div>
          </div>
  </vx-card>
  <vx-card v-if="is_loaded" title="Mass Balance Report">
    <vs-table :max-items="(meta.per_page) ? meta.per_page : 10"
              stripe :data="mass_balance_data" :sst="true"
              class="table-dark-inverted table-auto vs-con-loading__container" id="mass-balance-audit-table">
      <template slot="thead">
        <vs-th width="15%">SUNDRY ITEM CODE</vs-th>
        <vs-th width="15%">SUNDRY ITEM NAME</vs-th>
        <vs-th width="15%">SUNDRY ITEM ORDER CODE</vs-th>
        <vs-th width="20%">BATCH CODE</vs-th>
        <vs-th width="10%">AVAILABLE QUANTITY (ITEM)</vs-th>
        <vs-th width="5%">TOTAL QUANTITY (ITEM)</vs-th>
        <vs-th width="10%">SUPPLIER BATCH NUMBER</vs-th>
        <vs-th width="10%">SUPPLIER</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            {{ tr.sundry_item_code }}
          </vs-td>
          <vs-td>
            {{ tr.sundry_item_name }}
          </vs-td>
          <vs-td>
            <vx-tooltip class="text-primary cursor-pointer" text="View Sundry Order" position="top">
              <span @click.stop="onClickRawMaterialOrderView(tr.sundry_item_order_id)">
                 {{ tr.sundry_item_order_code}}
              </span>
            </vx-tooltip>
          </vs-td>
          <vs-td>
            {{ tr.batch_code }}
          </vs-td>
          <vs-td>
            {{ tr.available_quantity}}
          </vs-td>
          <vs-td>
            {{ tr.total_quantity}}
          </vs-td>
          <vs-td>
            {{ tr.supplier_batch_no}}
          </vs-td>
          <vs-td>
            {{ tr.supplier}}
          </vs-td>

          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full px-8">

              <vs-table  class="my-8" hoverFlat id="work_order_table" :data="tr.work_orders" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">WORK ORDERS</h5>
                </template>
                <template slot="thead">
                  <vs-th>WO CODE</vs-th>
                  <vs-th>WO DATE</vs-th>
                  <vs-th>QUANTITY USED IN WO</vs-th>
                  <vs-th>QC STATUS</vs-th>
                  <vs-th>WO STATUS</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      <vx-tooltip class="text-primary cursor-pointer" text="View Work Order" position="top">
                        <span @click.stop="onClickWorkOrderView(tr_item.id)">
                           {{ tr_item.work_order_code }}
                        </span>
                      </vx-tooltip>
                    </vs-td>
                    <vs-td>
                      {{ tr_item.work_order_date }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.quantity_used_in_wo }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.q_c_status || 'N/A' }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.status }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-table class="my-8" hoverFlat id="waste_item_table" :data="tr.waste" stripe>
                <template slot="header">
                  <h5 class="mb-4 text-warning">WASTE</h5>
                </template>
                <template slot="thead">
                  <vs-th>Quantity (ITEM)</vs-th>
                  <vs-th>STATUS</vs-th>
                  <vs-th>DISPOSE NOTE</vs-th>
                  <vs-th>DISPOSED BY</vs-th>
                  <vs-th>DISPOSED AT</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index_item"
                         v-for="(tr_item, index_item) in data">
                    <vs-td>
                      {{ tr_item.quantity }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.status }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.dispose_note || 'N/A'}}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.disposed_by_staff || 'N/A' }}
                    </vs-td>
                    <vs-td>
                      {{ tr_item.dispose_timestamp || 'N/A'}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </template>
        </vs-tr>
      </template>

  </vs-table>
    <vs-pagination
      v-on:changeMaxItems="changePage"
      :size-array="meta.total ? meta.total : 20"
      :max-items="perPage"
      description-body="Rows per page"
      description-connector="of"
      description-title="Records"
      description
      :description-items="descriptionItems"
      :total="(meta.last_page)? meta.last_page : 0"
      v-model="page"  class="p-5">
    </vs-pagination>
  </vx-card>
      </div>
    </div>
  </div>

</template>

<script>

import {RepositoryFactory} from "@/repository/RepositoryFactory";
import {defaultPagination, perPageList} from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import ErrorMessages from "@/mixins/ErrorMessages";
const ReportingRepository = RepositoryFactory.get('reporting')

export default {
  name: "SundryMassBalanceAudit",
  data(){
    return{
      mass_balance_data: [],
      meta:{},
      maxItems:20,
      page : 1,
      total: 0,
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {
        search: '',
        status: '',
      },
      is_loaded: false,
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [ ErrorMessages ],
  methods:{
    async getMasBalanceReportData() {
      try {
          this.is_loaded = false
          this.mass_balance_data = []
          const filterQuery = `filter[search]=${this.filters.search}&filter[status]=${this.filters.status ? this.filters.status : ''}`
          await this.$vs.loading()
          const {data} = await ReportingRepository.getSundryMassBalanceData(this.page, filterQuery, this.perPage)
          this.mass_balance_data = data.data
          this.meta = data.meta
          this.is_loaded = true
      }catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickClearSearch() {
      this.filters = {
        search: '',
        status: '',
      }
      await this.getMasBalanceReportData()
    },
    async onClickOrderDetailsView (id) {
      let route = this.$router.resolve({path: `/pages/product-orders/${id}`});
      window.open(route.href, '_blank');
    },
    async onClickFormulationView (id) {
      let route = this.$router.resolve({path: `/pages/formulations/${id}`});
      window.open(route.href, '_blank');
    },
    async onClickWorkOrderView (id) {
      let route = this.$router.resolve({path: `/pages/manufacturing/work-orders/${id}/details`});
      window.open(route.href, '_blank');
    },
    async onClickRawMaterialOrderView (id) {
      let route = this.$router.resolve({path: `/pages/sundry-items/orders/${id}`});
      window.open(route.href, '_blank');
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    toFormatDecimals(value) {
      return Number(value).toFixed(4)
    },
    soDispatchedToCustomer(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for !== 'Stock' && ['Dispatched', 'Customer-Received'].includes(x.item_status))
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    soNotDispatchedToCustomer(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for !== 'Stock' && !['Dispatched', 'Customer-Received'].includes(x.item_status))
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    workOrderWaste(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.waste.reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    woMadeForStock(work_orders) {
      return work_orders.reduce((acc, cur) => {
        return acc + cur.stock.filter((x) => x.made_for === 'Stock')
          .reduce((a, c) => a + parseFloat(c.rm_quantity), 0);
      }, 0);
    },
    rmWasteManagement(waste) {
      return waste.reduce((a, c) => a + parseFloat(c.quantity), 0)
    },
    massBalanceDiff(work_orders, waste, available_quantity, quantity, quantity_pending_to_receive) {
      let total = (quantity - quantity_pending_to_receive) - ( this.soDispatchedToCustomer(work_orders) + this.soNotDispatchedToCustomer(work_orders) +
        this.woMadeForStock(work_orders) + this.workOrderWaste(work_orders) + this.rmWasteManagement(waste) + parseFloat(available_quantity) )
      return Number(total).toFixed(4)
    }
  },
  watch : {
    page(){
      this.getMasBalanceReportData()
    },
    perPage() {
      this.getMasBalanceReportData()
    }
  }
}
</script>

<style scoped>

</style>
